import { createClient } from '@supabase/supabase-js';


const supabaseUrl = 'https://hbuctvafykfazgfahseo.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhidWN0dmFmeWtmYXpnZmFoc2VvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NzkwMTM2NCwiZXhwIjoyMDczNDc3MzY0fQ.XBkyb7V043quttbLciMLhAJirAN-9l4h18E_a2vi3EM';


if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
